import { render, staticRenderFns } from "./SAPK_rwjabatan_Modal.vue?vue&type=template&id=06ae97b0"
import script from "./SAPK_rwjabatan_Modal.vue?vue&type=script&lang=js"
export * from "./SAPK_rwjabatan_Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports